import { render, staticRenderFns } from "./infoqueen.vue?vue&type=template&id=3c2b01c2&"
import script from "./infoqueen.vue?vue&type=script&lang=js&"
export * from "./infoqueen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports